import { Dialog } from "@idg-web-platform/pulse";
import { useRef, useEffect } from "preact/hooks";
import SSI from "../ssi.tsx";

const ClubInformationDialog = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    if (isOpen) {
      dialogRef.current?.showModal?.();
    } else {
      dialogRef.current?.close?.();
    }
  }, [isOpen]);

  useEffect(() => {
    dialogRef.current?.addEventListener("close", onClose);
    return () => {
      dialogRef.current?.removeEventListener("close", onClose);
    };
  }, [onClose]);

  return (
    <Dialog ref={dialogRef} role="dialog">
      <SSI url="/fragments/b/clubpoints-content" />
    </Dialog>
  );
};

export default ClubInformationDialog;
